var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionType } from "./StateReducer.types";
var StateReducer = /** @class */ (function () {
    function StateReducer(initial) {
        this.state = { isLight: initial };
    }
    /**
     * Apply an action to the current state.
     * @param action The action to be performed
     * @returns A boolean indicating whether the action was successful.
     */
    StateReducer.prototype.do = function (action) {
        switch (action) {
            case ActionType.LIGHT:
                if (this.state.isLight)
                    return false;
                this.state = { isLight: true };
                return true;
            case ActionType.DARK:
                if (!this.state.isLight)
                    return false;
                this.state = { isLight: false };
                return true;
            case ActionType.TOGGLE:
                this.state = { isLight: !this.state.isLight };
                return true;
        }
    };
    /**
     * Get the current state.
     * @returns An immutable copy of the current state.
     */
    StateReducer.prototype.get = function () {
        return Object.freeze(__assign({}, this.state));
    };
    return StateReducer;
}());
export { StateReducer };
